import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";


const ProcesosInternos = () => {
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal">
                <br /> <h1>Procesos y Actividades Ingeniería</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div clasName="Text_Buttons_Radio_buttons">
                <p clasName="ParrafoPrincipal">
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">
          <table class="styled-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nombre Del Proceso</th>
                <th>Descripcion</th>
                <th>Diagramas/Narrativas</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <p>
                    <b>Procesos POC</b>
                  </p>
                </td>
                <td>
                  <p>
                    Una Prueba de Concepto (PoC) se puede 
                    definir de manera sencilla como un proceso inicial y práctico 
                    para evaluar la viabilidad y eficacia de una idea o tecnología 
                    antes de comprometerse completamente con su implementación a gran escala.
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/procesos-internos/procesos-poc"
                  >
                    Procedimiento
                  </Button>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/procesos-internos/procesos-poc-raci"
                  >
                    Matriz RACI
                  </Button>
                </td>
              </tr>
              <tr>
                <td>2</td>
                <td>
                  <p>
                    <b>Mantenimiento Preventivo</b>
                  </p>
                </td>
                <td>
                  <p>
                  Después de completar una instalación, programar y documentar mantenimientos 
                  preventivos es fundamental para garantizar la continuidad operativa y la 
                  satisfacción del cliente. Un plan de revisiones periódicas permite detectar 
                  posibles fallas antes de que ocurran y refuerza la confianza en nuestros servicios.
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/procesos-internos/mantenimiento-preventivo"
                  >
                    Procedimiento
                  </Button>
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  <p>
                    <b>Mantenimiento Correctivo</b>
                  </p>
                </td>
                <td>
                  <p>
                  Cuando se presenta una incidencia o falla, es esencial contar con un protocolo 
                  de mantenimiento correctivo que clasifique los casos por nivel de severidad 
                  (crítico, alto, medio, bajo) y aplique los tiempos de respuesta y resolución 
                  definidos en el SLA, garantizando la continuidad operativa del cliente.
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/procesos-internos/mantenimiento-correctivo"
                  >
                    Procedimiento
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default ProcesosInternos;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
